import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, TextField } from "@mui/material";
import { useState } from "react";

import { GeoRehandleDTO } from "../../../DTOs/Geology/GeoRehandleDTO";
import { LocationDTO } from "../../../DTOs/Production/LocationDTO";

type MovementToCellProps = {
  entry: GeoRehandleDTO,
  crushingMovementToLocationOptions: LocationDTO[],
  isCrushingMovementToLocationOptionsLoading: boolean
  handleUpdateRow: (row: GeoRehandleDTO) => Promise<boolean | undefined>
  isShiftLocked: boolean
}

const MovementToCell: React.FC<MovementToCellProps> = ({
  entry,
  crushingMovementToLocationOptions,
  isCrushingMovementToLocationOptionsLoading,
  handleUpdateRow,
  isShiftLocked
}) => {
  const [isLoading, setLoading] = useState(false);

  return (
    <Autocomplete
      disabled={isShiftLocked}
      classes={{ root: 'w-full' }}
      size="small"
      loading={isCrushingMovementToLocationOptionsLoading}
      options={crushingMovementToLocationOptions}
      value={crushingMovementToLocationOptions.find(x => x.id === entry.movementToId) ?? null}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.name}
      onChange={async (_event, newValue) => {
        if (newValue) {
          setLoading(true);
          await handleUpdateRow(
            { ...entry, movementToId: newValue.id }
          );
          setLoading(false);
        }
      }}
      renderOption={(props, option) => (
        <li
          {...props}
          key={option.id}
        >
          <span
            className="text-theme-danger-light">{option.name}</span>
        </li>
      )}
      renderInput={(params) => {

        return <TextField
          {...params}
          label="Movement To"
          slotProps={{
            ...params.slotProps,
            input: {
              ...params.slotProps.input,
              style: {
                color: "red",
                transition: "color 0.2s ease-in-out"
              },
              endAdornment: (
                <>
                  {(isLoading || isCrushingMovementToLocationOptionsLoading) &&
                    <FontAwesomeIcon className="text-theme-text" icon={faSpinner} spin />}
                  {params.slotProps.input.endAdornment}
                </>
              )
            }
          }}
        />
      }}
    />);
};

export default MovementToCell;